import { Col, Row } from "react-bootstrap";
import MarginStatementHeaderItem from "../MarginStatementHeaderItem";
import { React } from "react";
import * as marginSelectors from "../../../../selectors/margin";
import _ from "lodash";
function MarginStatementHeaderComponent({ data,loading=false }) {
  const summary = _.get(data, ["summary"], null);
  const clientCode = marginSelectors.getMarginSummaryClientCode(summary)
  const clientName = marginSelectors.getMarginSummaryClientName(summary)
  const clientCDS = marginSelectors.getMarginSummaryCDSNumber(summary)
  const totalCreditLimit = marginSelectors.getSummaryDetailFullText(
      marginSelectors.getMarginSummaryTotalCreditLimit(summary),
  );
  const totalAccumInterest = marginSelectors.getSummaryDetailFullText(
      marginSelectors.getMarginSummaryTotalAccumInterest(summary),
  );
  const espEffectiveDate = marginSelectors.getSummaryDetailText(
    marginSelectors.getMarginSummaryEspEffectiveDate(summary),
  );
  const totalOutstandingAmount = marginSelectors.getSummaryDetailFullText(
    marginSelectors.getMarginSummaryTotalOutstandingAmount(summary),
  );
  const totalMarginValue = marginSelectors.getSummaryDetailFullText(
    marginSelectors.getMarginSummaryTotalMarginValue(summary),
  );

  const totalPurchaseAmount = marginSelectors.getSummaryDetailFullText(
    marginSelectors.getMarginSummaryTotalPurchaseAmount(summary),
  );

  const totalSaleAmount = marginSelectors.getSummaryDetailFullText(
    marginSelectors.getMarginSummaryTotalSaleAmount(summary),
  );
  const totalMarketValue = marginSelectors.getSummaryDetailFullText(
    marginSelectors.getMarginSummaryTotalMarketValue(summary),
  );
  const totalOtherValue = marginSelectors.getSummaryDetailFullText(
    marginSelectors.getMarginSummaryTotalOtherValue(summary),
  );

  const totalContraAmount = marginSelectors.getSummaryDetailFullText(
    marginSelectors.getMarginSummaryTotalContraAmount(summary),
  );
  const marginPos = marginSelectors.getMarginSummaryMarginPosition(summary);
  const percentum = marginSelectors.getMarginSummaryPercentum(summary);
  const marginShortFall = marginSelectors.getSummaryItemMarginShortfallFullText(summary);
  return (
    <div className="my-3">
      <Row>
        <Col md={6} lg={4} xl={3} >
          <MarginStatementHeaderItem loading={loading} title="Margin Shortfall" value={marginShortFall}></MarginStatementHeaderItem>
          <MarginStatementHeaderItem loading={loading} title="Credit Limit" value={totalCreditLimit}></MarginStatementHeaderItem>
          <MarginStatementHeaderItem loading={loading} title="Accrued Interest" value={totalAccumInterest}></MarginStatementHeaderItem>
          <MarginStatementHeaderItem
            title="Others / Trust"
            value={totalOtherValue}
            loading={loading}
          ></MarginStatementHeaderItem>
        </Col>
        <Col md={6} lg={4} xl={3}>
          <MarginStatementHeaderItem loading={loading} title="Outstanding" value={totalOutstandingAmount}></MarginStatementHeaderItem>
          <MarginStatementHeaderItem
            title="Purchases"
            value={totalPurchaseAmount}
            loading={loading}
          ></MarginStatementHeaderItem>
          <MarginStatementHeaderItem loading={loading} title="Sales" value={totalSaleAmount}></MarginStatementHeaderItem>
          <MarginStatementHeaderItem loading={loading} title="Contras" value={totalContraAmount}></MarginStatementHeaderItem>
        </Col>
        <Col md={6} lg={4} xl={3}>
          <MarginStatementHeaderItem loading={loading} title="Market Value" value={`${totalMarketValue}`}></MarginStatementHeaderItem>
          <MarginStatementHeaderItem loading={loading} title="Margin Value" value={`${totalMarginValue}`}></MarginStatementHeaderItem>
          <MarginStatementHeaderItem loading={loading} title="Margin Position" value={marginPos}></MarginStatementHeaderItem>
          <MarginStatementHeaderItem loading={loading} title="Percentum" value={percentum}></MarginStatementHeaderItem>
        </Col>
      </Row>
    </div>
  );
}

export default MarginStatementHeaderComponent;
